<template>
	<div class="collapsible" :class="{open:isOpen}">
		<slot></slot>
	</div>
</template>

<script>
import Vue from 'vue';
export default {
	name: 'Collapsible',
	props: ['open', 'data', 'minHeight'],
	data() {
		return {
			isOpen: this.open,
			padding: 50
		};
	},
	watch: {
		open(isOpen, wasOpen) {
			let vm = this;
			this.isOpen = isOpen;
			if (isOpen) {
				const childEl = vm.$el && vm.$el.children[0];
				if (childEl) {
					vm.$el.style.maxHeight = (Math.max((childEl.getBoundingClientRect().height), (this.minHeight || 0)) + this.padding)+ 'px';
				}

			} else {
				vm.$el.style.maxHeight = 0;
				this.$emit('collapsible-closed');
			}
		},
		data(val, was) {
			let vm = this;
			Vue.nextTick()
				.then(() => {
					vm.$el.style.maxHeight = (vm.$el.children[0].getBoundingClientRect().height + 20) + 'px';
				});
		},

	}
};
</script>



// WEBPACK FOOTER //
// ./src/components/Collapsible.vue